import { axios } from './index';

export default {
	/**
	 * Get all towns
	 */
	all(data) {
		return axios.get('towns', {
				params: data
			})
			.then(response => Promise.resolve(response.data))
			.catch(error => Promise.reject(error.response.data));
	}
}


// WEBPACK FOOTER //
// ./src/services/towns.js